/**
 * Parse the content timestamp emitted by relay.
 *
 * `null` means the payload did not carry a usable source clock, so callers
 * can deliberately fall back to receipt time without confusing both clocks.
 */
export function parseSourceTimestampMs(value: unknown): number | null {
  if (value === null || value === undefined || value === "") return null;
  if (!(typeof value === "string" || typeof value === "number" || value instanceof Date)) {
    return null;
  }

  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : null;
}
